module.exports = __webpack_public_path__ + "static/media/info-white.0be71caa.svg";